import styled from '@emotion/styled';
import Button from '@vromo/ui/components/Button';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import theme from '@vromo/ui/components/theme';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
`;

export const InnerContainer = styled.div`
  width: 100%; overflow: auto; marginTop: 15px;
`;

export const RuleTab = styled.div`
    align-content: center;
    border: 1px solid ${theme.lightGrey};
    box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 20px;
    transition: all 200ms ease-in-out;

    &:hover {
        box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.1);
    }
`;

export const RuleControl = styled.div`
    align-items: center;
    display: flex;

    i {
        color: ${theme.grey};
        cursor: pointer;
        font-size: 1.5em;
        margin-right: 10px;
        transition: color 200ms ease-in-out;

        &:hover {
            color: ${theme.mediumGrey};
        }
    }
`;

export const ActionButton = styled(Button)`
    margin-right: 10px;
`
export const ClearError = styled(FontAwesome)`
    color: ${theme.mediumGrey};
    cursor: pointer;
    margin-left: 10px;
    transition: color 200ms ease-in;
    
    &:hover {
        color: red;
    }
`;

export const OuterWrapper = styled.div<{full?: boolean}>`
  alignItems: center;
  display: flex;
  flex: auto;
  margin-left: 15px;
  ${({ full }) => full && 'width: 100%; height: 100%;'} 
`

export const DropDownWrapper = styled.div<{ full?: boolean }>`
    margin-left: 5px;
    ${({ full }) => full && 'width: 100%; height: 100%;'} 
`

export const InputWrapper = styled.div`flex: 1;`
